import axios from 'axios'

export default {
  getMaterialCatalogueTree(params) {
    return axios.post(
      '/api/rendering/admin/front/material/catalogue/getMaterialCatalogueTree',
      params,
    )
  },
  deleteMaterialCatalogue(params) {
    return axios.post(
      '/api/rendering/admin/front/material/catalogue/deleteMaterialCatalogue',
      params,
    )
  },
  addMaterialCatalogue(params) {
    return axios.post('/api/rendering/admin/front/material/catalogue/addMaterialCatalogue', params)
  },
  getMaterialList(params) {
    return axios.post('/api/rendering/admin/front/material/info/getMaterialList', params)
  },
  getMaterialById(params) {
    return axios.post('/api/rendering/admin/front/material/info/getMaterialById', params)
  },
  updateMaterial(params) {
    return axios.post('/api/rendering/admin/front/material/info/updateMaterial', params)
  },
  uploadExampleFile(params) {
    return axios.post('/api/rendering/admin/front/material/info/uploadExampleFile', params)
  },
  deleteMaterial(params) {
    return axios.post('/api/rendering/admin/front/material/info/deleteMaterial', params)
  },
  addMaterial(params) {
    return axios.post('/api/rendering/admin/front/material/info/addMaterial', params)
  },
}
